import {
    useMemo,
    useState
} from "react";

import "./CriarBannerCategoria.css";

function CriarBannerCategoria({
    categorias,
    onClose,
    onSalvar
}) {
    const [busca, setBusca] =
        useState("");

    const [mostrarOpcoes, setMostrarOpcoes] =
        useState(false);

    const [grupoSelecionado,
        setGrupoSelecionado] =
        useState(null);

    const [arquivo, setArquivo] =
        useState(null);

    const [preview, setPreview] =
        useState(null);

    const [salvando, setSalvando] =
        useState(false);

    const categoriasFiltradas =
        useMemo(() => {
            const texto =
                busca.toLowerCase();

            return categorias.filter(
                (categoria) =>
                    categoria.descricao
                        ?.toLowerCase()
                        .includes(texto) ||
                    String(
                        categoria.codgrupo
                    ).includes(texto)
            );
        }, [busca, categorias]);

    const handleSelecionarImagem =
        (e) => {
            const file =
                e.target.files?.[0];

            if (!file) return;

            setArquivo(file);

            const reader =
                new FileReader();

            reader.onload =
                (event) => {
                    setPreview(
                        event.target.result
                    );
                };

            reader.readAsDataURL(file);
        };

    const handleSalvar =
        async () => {
            if (
                !grupoSelecionado
            ) {
                alert(
                    "Selecione uma categoria."
                );
                return;
            }

            if (!arquivo) {
                alert(
                    "Selecione uma imagem."
                );
                return;
            }

            try {
                setSalvando(true);

                const formData =
                    new FormData();

                formData.append(
                    "imagem",
                    arquivo
                );

                const uploadResponse =
                    await fetch(
                        "https://app.eliandroalimentos.com.br/api/imagem/upload",
                        {
                            method:
                                "POST",
                            body:
                                formData,
                        }
                    );

                const uploadData =
                    await uploadResponse.json();

                if (
                    !uploadResponse.ok
                ) {
                    throw new Error(
                        uploadData.message
                    );
                }

                const response =
                    await fetch(
                        "https://app.eliandroalimentos.com.br/api/home_media/criarbanner",
                        {
                            method:
                                "POST",
                            headers: {
                                "Content-Type":
                                    "application/json",
                            },
                            body: JSON.stringify(
                                {
                                    imagem:
                                        uploadData.caminho,
                                    localizacao:
                                        "introbannercategoria",
                                    ordem:
                                        grupoSelecionado.codgrupo,
                                }
                            ),
                        }
                    );

                const data =
                    await response.json();

                if (
                    !response.ok
                ) {
                    throw new Error(
                        data.message
                    );
                }

                onSalvar?.();
            } catch (error) {
                console.error(
                    error
                );

                alert(
                    error.message
                );
            } finally {
                setSalvando(false);
            }
        };

    return (
        <div
            className="criarBannerCategoria-overlay"
            onClick={onClose}
        >
            <div
                className="criarBannerCategoria-container"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >
                <div className="criarBannerCategoria-header">
                    <h2>
                        Nova Categoria (1654 × 827 px) .jpg
                    </h2>

                    <button
                        onClick={
                            onClose
                        }
                    >
                        ✕
                    </button>
                </div>



                <div className="criarBannerCategoria-autocomplete">
                    <input
                        type="text"
                        placeholder="Buscar categoria..."
                        value={busca}
                        onChange={(e) => {
                            setBusca(
                                e.target.value
                            );

                            setMostrarOpcoes(
                                true
                            );

                            setGrupoSelecionado(
                                null
                            );
                        }}
                        onFocus={() => {
                            if (busca.trim()) {
                                setMostrarOpcoes(
                                    true
                                );
                            }
                        }}
                    />

                    {mostrarOpcoes &&
                        busca.trim() &&
                        categoriasFiltradas.length >
                        0 && (
                            <div className="criarBannerCategoria-dropdown">
                                {categoriasFiltradas.map(
                                    (
                                        categoria
                                    ) => (
                                        <div
                                            key={
                                                categoria.codgrupo
                                            }
                                            className="criarBannerCategoria-dropdownItem"
                                            onClick={() => {
                                                setGrupoSelecionado(
                                                    categoria
                                                );

                                                setBusca(
                                                    `${categoria.codgrupo} - ${categoria.descricao}`
                                                );

                                                setMostrarOpcoes(
                                                    false
                                                );
                                            }}
                                        >
                                            {
                                                categoria.codgrupo
                                            }
                                            {" - "}
                                            {
                                                categoria.descricao
                                            }
                                        </div>
                                    )
                                )}
                            </div>
                        )}
                </div>

                <input
                    type="file"
                    accept="image/*"
                    onChange={
                        handleSelecionarImagem
                    }
                />

                {preview && (
                    <>
                        <div className="criarBannerCategoria-previewOriginal">
                            <img
                                src={
                                    preview
                                }
                                alt=""
                            />
                        </div>

                        <div className="criarBannerCategoria-previewSite">
                            <img
                                src={
                                    preview
                                }
                                alt=""
                            />
                        </div>
                    </>
                )}

                <div className="criarBannerCategoria-footer">
                    <button
                        onClick={
                            onClose
                        }
                    >
                        Cancelar
                    </button>

                    <button
                        onClick={
                            handleSalvar
                        }
                        disabled={
                            salvando
                        }
                    >
                        {salvando
                            ? "Salvando..."
                            : "Salvar"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CriarBannerCategoria;